import { webrtcManager } from '../services/webrtc';
import { useCallStore } from '../store/callStore';
import { isWebViewMode } from '../utils/webviewBridge';
import {
  setNativeVideoRuntimeLocalVideoEnabled,
  toggleNativeAudioRuntimeMute
} from '../services/callRuntime';

export async function toggleVideo() {
  const activeCall = useCallStore.getState().activeCall;
  if (isWebViewMode && activeCall) {
    const nextEnabled = !(activeCall.localVideoEnabled === true);
    setNativeVideoRuntimeLocalVideoEnabled(activeCall.callSessionId, nextEnabled);
    useCallStore.getState().setVideoEnabled(nextEnabled);
    return nextEnabled;
  }
  const enabled = await webrtcManager.toggleVideo();
  useCallStore.getState().setVideoEnabled(enabled);
  return enabled;
}

export function toggleAudio() {
  const activeCall = useCallStore.getState().activeCall;
  if (isWebViewMode && activeCall) {
    const nextMuted = activeCall.audioEnabled;
    toggleNativeAudioRuntimeMute(activeCall.callSessionId, nextMuted);
    useCallStore.getState().setAudioEnabled(!nextMuted);
    return !nextMuted;
  }
  const enabled = webrtcManager.toggleAudio();
  useCallStore.getState().setAudioEnabled(enabled);
  return enabled;
}
